const defaultState = {
    contracts: [], // Add this in your state
    siteId: {},
    // ... other state properties
};

const mutations = {
    setContractsState(state, contracts) {
        state.contracts = contracts;
    },
    resetContractsState(state) {
        state.contracts = [];
    },
    setSiteContract(state, siteId) {
        state.siteId = siteId;
    },
    resetSiteInfo(state) {
        state.siteId = {};
    },
};

const actions = {
    async getContractsInfo({ commit, dispatch }, { teamId, siteId }) {
        try {
            const { data } = await this.$rq.getContractsForTeam({ teamId, siteId });
            commit('setContractsState', data);
        } catch (err) {
            dispatch('resetContractsInfo');
        }
    },
    setSiteInfo({ commit }, siteId) {
        commit('setSiteContract', siteId);
    },
    resetContractsInfo({ commit }) {
        commit('resetContractsState');
    },
    async getSiteInfo({ commit, dispatch }, siteId) {
        try {
            const { data } = siteId;
            commit('setSiteContract', data);
        } catch (err) {
            dispatch('resetSiteInfo');
        }
    },
};

const getters = {
    contracts: state => state.contracts,
    siteId: state => state.siteId,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
